import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'

export type MessageSchema = typeof ko | typeof en | typeof ja

const messages = {
  ko: ko,
  'ko-KR': ko,
  en: en,
  'en-US': en,
  ja,
  'ja-JP': ja,
}

export const i18n = createI18n<[MessageSchema], keyof typeof messages>({
  locale: navigator.language,
  fallbackLocale: 'en',
  fallbackWarn: false,
  messages,
  legacy: false,
})
